<template>
  <button type="button" class="mbtn btn-primary">
    <span class="fas fa-filter"></span>
    Filter
  </button>
</template>

<style scoped>
.btn-primary .fa-filter {
  position: relative;
  font-size: 14px;
  /* margin-right: -20px; */
}
</style>
